export default "__VITE_ASSET__0a707b58__"